<template>
  <footer class="page-footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <h6 class="_margin-bottom-0">Our customer services email</h6> <a
            :href="`mailto:${appSettings.supplierEmail}`">{{ appSettings.supplierEmail }}</a>

          <contact-us class="_margin-top-20" />
        </div>
        <div class="col-xs-6 text-right">
          <a :href="appSettings.supplierTermsAndConditions" target="_blank">Terms & Conditions</a>
          <a class="padding-left" :href="appSettings.supplierPrivacyPolicy" target="_blank">Privacy Policy</a>

          <div class="_margin-top-20">
            <img height="30" src="../../../assets/powerby-dark.svg" />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import ContactUs from '../contact-us/ContactUs';

export default {
  name: 'PageFooter',
  computed: {
    ...mapState({
      appSettings: ({ app_settings }) => app_settings
    })
  },
  components: {
    ContactUs
  }
};
</script>

<style lang="scss">
.page-footer {
  background: #f4f4f4;
  padding: 15px;
  margin-top: 40px;

  a {
    font-size: 14px;
    color: #686868;
    font-weight: bold;

    &:hover,
    &:focus {
      color: $brand-colour-primary;
    }

    @media (max-width: 767px) {
      display: block;
      margin-bottom: 5px;
    }
  }

  .padding-left {
    padding-left: 15px;
  }
}
</style>
